"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthGate = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const useSession_1 = require("../../hooks/useSession");
const DefaultLoadingFallback_1 = require("./DefaultLoadingFallback");
const constants_1 = require("../../../constants");
const LoginRedirect = () => {
    (0, react_1.useEffect)(() => {
        if (typeof window === 'undefined') {
            return;
        }
        const params = new URLSearchParams();
        params.set('destination', `${window.location.pathname}${window.location.search}`);
        const redirectTo = `${constants_1.IDENTITY_BASE_PATH}/login?${params.toString()}`;
        window.location.assign(redirectTo);
    }, []);
    return null;
};
const AuthGate = ({ children, loadingFallback = (0, jsx_runtime_1.jsx)(DefaultLoadingFallback_1.DefaultLoadingFallback, {}), unauthenticatedFallback = (0, jsx_runtime_1.jsx)(LoginRedirect, {}), isPublic = false, }) => {
    const session = (0, useSession_1.useSession)();
    if (isPublic) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
    }
    if (session.status === 'loading') {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: loadingFallback });
    }
    if (session.status === 'unauthenticated') {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: unauthenticatedFallback });
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
};
exports.AuthGate = AuthGate;
